import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core"
import moment from 'moment';
import { GET_SHIP_BOX_DETAILS, shipBoxListQuery } from './shipbox_gql';
import ShipBoxDialog from "./ShipBoxDialog"

function ShipBoxTable(props) {
  const [detailsVisible, setDetailsVisible] = useState(false);

  const [getShipBoxDetails, { data: detailsData }] = useLazyQuery(GET_SHIP_BOX_DETAILS, {
    fetchPolicy: "network-only",
    onCompleted: () => { setDetailsVisible(true) }
  });

  const showShipBoxDetails = (shipBoxId) => {
    getShipBoxDetails({
      variables: { shipBoxId: shipBoxId}
    })
  }

  const row = (shipBox) => {
    return (
      <TableRow key={shipBox.shipBoxId}>
        <TableCell><Link href="#" onClick={() => showShipBoxDetails(shipBox.shipBoxId)}>{shipBox.shipName}</Link></TableCell>
        <TableCell>{shipBox.shipExtra}</TableCell>
        <TableCell>{moment(shipBox.shipDate).format('MM/DD/YYYY')}</TableCell>
        <TableCell>{shipBox.createdBy}</TableCell>
      </TableRow>
    )
  }

  const body = (shipBoxList) => {
    return (
      <TableBody>
        {shipBoxList.map(sb => row(sb))}
      </TableBody>
    );
  }

  return (
    <React.Fragment>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Extra</TableCell>
              <TableCell>Ship Date</TableCell>
              <TableCell>Created By</TableCell>
            </TableRow>
          </TableHead>
          {body(props.data.shipBoxList)}
        </Table>
      </TableContainer>
      <ShipBoxDialog shipBox={detailsData?.shipBoxDetail} visible={detailsVisible} setVisible={setDetailsVisible}/>
    </React.Fragment>
  )
}

export default function ShipBoxTableW(props) {
  return (shipBoxListQuery(ShipBoxTable, props))
};
